import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import MainNavigation from './MainNavigation';
import jwtDecode from 'jwt-decode';
import store from 'store2';
import config from '../../config';
import { getUserRoles } from '../auth/actions';
import { fetchSubmittalsPendingReviewCount } from '../../swing-submittals/actions';

class AdminLayout extends Component {
  componentDidMount() {
    const { dispatch } = this.props;

    const token = jwtDecode(store.get(config.auth.idTokenKey));
    dispatch(getUserRoles(token.sub));
    dispatch(fetchSubmittalsPendingReviewCount());
  }

  componentWillReceiveProps(nextProps) {
    if (
      !this.props.roles.get('loaded') &&
      nextProps.roles.get('loaded') &&
      !nextProps.roles.get('data').includes('role-admin')
    ) {
      this.props.history.push('/logout');
    }
  }

  render() {
    return (
      <div className="main-layout">
        <div className="main-layout__children__wrapper">
          <MainNavigation
            submittalsPendingReviewCount={this.props.submittalsPendingReviewCount.getIn(['data', 'count'])}
          />
          <div className="main-layout__children">{this.props.children}</div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    submittalsPendingReviewCount: state.swingSubmittals.pendingReviewCount,
    roles: state.auth.roles,
  };
};

export default withRouter(connect(mapStateToProps)(AdminLayout));



// WEBPACK FOOTER //
// ./src/common/layout/AdminLayout.js